import { StateModel } from 'src/shared/models';
import {
  GET_MESSAGE_TO_ADMIN,
  GET_MESSAGE_TO_ADMIN_ERROR,
  GET_MESSAGE_TO_ADMIN_SUCCESS,
  DELETE_MESSAGE_TO_ADMIN,
  DELETE_MESSAGE_TO_ADMIN_SUCCESS,
  DELETE_MESSAGE_TO_ADMIN_ERROR,
} from '../actions/message-to-admin.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: {},
};

export const messageToAdminReducer = (
  state: StateModel = INITIAL_STATE,
  { type, payload, error }: any,
) => {
  switch (type) {
    case GET_MESSAGE_TO_ADMIN:
      return {
        ...state,
        loaded: false,
        loading: true,
      };
    case GET_MESSAGE_TO_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload,
      };
    case GET_MESSAGE_TO_ADMIN_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error,
      };
    case DELETE_MESSAGE_TO_ADMIN:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case DELETE_MESSAGE_TO_ADMIN_SUCCESS:
      const content = state.data.content.filter(
        ({ id }: any) => id !== payload.importConfigurationId,
      );
      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state.data,
          content,
        },
      };
    case DELETE_MESSAGE_TO_ADMIN_ERROR:
      return {
        ...state,
        loading: false,
        loaded: true,
        error,
      };

    default:
      return state;
  }
};
